// Toggle admin do acompanhamento de líderes (painel Tecnologia). Liga/desliga a
// automação: 1 nudge à líder ~12h após o handoff + escala à diretoria em 24h.
// Persiste em system_settings.leader_followup_enabled via
// /api/admin/settings/leader-followup. A baixa MANUAL (painel Líderes + sidebar
// da conversa) funciona independente deste toggle — ele só controla o automático.
import { useState, useEffect, useCallback } from 'react'
import { FiAward, FiAlertTriangle } from 'react-icons/fi'
import { useAuth } from '../contexts/AuthContext'
import { API_ENDPOINTS } from '../lib/api'

export function LeaderFollowupToggle() {
  const { authenticatedFetch } = useAuth()
  const [enabled, setEnabled] = useState<boolean | null>(null)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    try {
      const r = await authenticatedFetch(API_ENDPOINTS.LEADER_FOLLOWUP)
      const d = await r.json()
      if (!d.success) throw new Error()
      setEnabled(d.enabled)
    } catch { setError('Falha ao ler config') }
  }, [authenticatedFetch])

  useEffect(() => { refresh() }, [refresh])

  const toggle = async () => {
    if (saving || enabled === null) return
    setSaving(true)
    setError(null)
    try {
      const r = await authenticatedFetch(API_ENDPOINTS.LEADER_FOLLOWUP, {
        method: 'PUT',
        body: JSON.stringify({ enabled: !enabled }),
      })
      const d = await r.json()
      if (!r.ok || !d.success) throw new Error(d.error || `HTTP ${r.status}`)
      setEnabled(d.enabled)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Falha ao salvar')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="glass-panel neu-card rounded-2xl p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <FiAward className="w-4 h-4 text-primary shrink-0" />
          <div className="min-w-0">
            <div className="text-sm font-semibold text-foreground leading-tight">Acompanhamento de líderes</div>
            <div className="text-[11px] text-muted-foreground">Nudge ~12h + escala à diretoria em 24h</div>
          </div>
        </div>
        <button
          role="switch" aria-checked={!!enabled}
          onClick={toggle}
          disabled={saving || enabled === null}
          title="Quando ligado: 1 lembrete automático à líder ~12h após o encaminhamento (só 08–20h) + escala à diretoria em 24h sem retorno. A baixa manual (painel Líderes e sidebar da conversa) funciona sempre, independente deste toggle."
          className={`relative w-11 h-6 rounded-full shrink-0 transition-colors duration-200 disabled:opacity-50 neu-switch ${enabled ? 'bg-primary' : 'bg-muted neu-switch-off'}`}
        >
          <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full neu-knob transition-transform duration-200 ${enabled ? 'translate-x-5' : 'translate-x-0'}`} />
        </button>
      </div>
      {enabled && (
        <div className="flex items-start gap-1 text-[10px] text-amber-600 dark:text-amber-400">
          <FiAlertTriangle className="w-3 h-3 mt-0.5 shrink-0" />
          <span>Envia mensagens <b>MARKETING</b> reais às líderes (custo Meta). 1 nudge por lead pendente em ~12h; escala em 24h.</span>
        </div>
      )}
      {error && <div className="text-[10px] text-red-600 dark:text-red-400">{error}</div>}
    </div>
  )
}
